import Profile from '../types/Profile'

export const getFullName = (profile: Profile): string => {
  return `${profile.first_name} ${profile.last_name}`
}
